module.exports = __webpack_public_path__ + "static/img/IMG_0380.a540ac1.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/slides/New folder/news/IMG_0380.jpg
// module id = aw5j
// module chunks = 1